import BaseService from '@/services/base/base.service';
import axios from 'axios';

class EmailVerificationService extends BaseService {
  public async sendOtp(
    email: string,
    language: string,
  ): Promise<SendOtpResponse> {
    const response = await axios.post<SendOtpResponse>(
      `${super.clientsApiBaseUrl()}/mobile/email-verification/send`,
      {
        email,
        language,
      },
    );
    return response.data;
  }

  public async verifyOtp(
    email: string,
    code: string,
  ): Promise<VerifyOtpResponse> {
    const response = await axios.post<VerifyOtpResponse>(
      `${super.clientsApiBaseUrl()}/mobile/email-verification/verify`,
      { email, code },
    );
    return response.data;
  }
}

export const emailVerificationService = new EmailVerificationService();

export interface SendOtpResponse {
  success: boolean;
  expiresInSeconds?: number;
  error?: string;
}

export interface VerifyOtpResponse {
  verified: boolean;
  error?: string;
}
